import defaultState from './state';

const SAVE_CURRENT_STUDENT = (state, student) => {
  state.currentStudent = student;
};

const SAVE_CURRENT_STUDENT_NAME = (state, name) => {
  state.currentStudentName = name;
};

export default {
  SAVE_CURRENT_STUDENT,
  SAVE_CURRENT_STUDENT_NAME
};



// WEBPACK FOOTER //
// ./src/store/modules/students/mutations.js